module.exports = __webpack_public_path__ + "static/media/apps.a36797b0.png";